export default "__VITE_ASSET__739eda68__"